"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StyleTitle = exports.StyleSubTitle = exports.StyleSeparator = exports.StyleContainer = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _color = _interopRequireDefault(require("webmotors-react-pj/tokens/color"));
var _responsive = _interopRequireDefault(require("webmotors-react-pj/tokens/responsive"));
var _variables = _interopRequireDefault(require("@webmotors/eleanor-ui/webmotors/_variables.json"));
var _default = exports.default = _styledComponents.default.p.withConfig({
  componentId: "sc-1y9so06-0"
})(["color:", ";font-size:1.4rem;text-align:center;padding:0 16px 32px;"], (0, _color.default)('gray-2'));
const StyleContainer = exports.StyleContainer = _styledComponents.default.div.withConfig({
  displayName: "StyleContainer",
  componentId: "sc-1y9so06-1"
})(["display:flex;align-self:flex-start;justify-content:flex-start;flex-direction:column;overflow:hidden;padding-bottom:20px;.modal__icon{height:26px;width:21px;margin-left:8px;}.input__search{width:96%;}button{width:98px;height:40px;display:flex;align-items:center;justify-content:center;position:fixed;bottom:24px;}@media ", "{button{bottom:40px;}}"], _responsive.default.lg);
const StyleTitle = exports.StyleTitle = _styledComponents.default.h1.withConfig({
  displayName: "StyleTitle",
  componentId: "sc-1y9so06-2"
})(["font-size:20px;font-style:normal;font-weight:500;line-height:30px;letter-spacing:", ";text-align:left;margin-bottom:8px;"], _variables.default['$ds-letter-spacing-default']);
const StyleSubTitle = exports.StyleSubTitle = _styledComponents.default.p.withConfig({
  displayName: "StyleSubTitle",
  componentId: "sc-1y9so06-3"
})(["font-size:12px;font-style:normal;font-weight:400;line-height:18px;letter-spacing:", ";text-align:left;margin-bottom:20px;"], _variables.default['$ds-letter-spacing-default']);
const StyleSeparator = exports.StyleSeparator = _styledComponents.default.span.withConfig({
  displayName: "StyleSeparator",
  componentId: "sc-1y9so06-4"
})(["display:none;border:1px solid ", ";margin:", ";@media ", "{display:block;}"], (0, _color.default)('gray-4'), props => props.margin ? props.margin : '8px 0px 16px 0px', _responsive.default.lg);